export default __webpack_public_path__ + "static/media/home-banner-3.79f04575.png";